import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query'
import Select from 'react-select'

import { fetchMembers } from 'api/actions/collaboration'
import { fetcher } from 'api/client'
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

export function TenantMembersSelect({ contractId, withGroups, ...rest }) {
    const { t } = useTranslation();
    const [groupOptions, setGroupOptions] = useState([])
    const { isLoading } = useQuery(['contract', contractId, 'members'], ({ queryKey: [, contractId] }) => fetcher(fetchMembers({
        contractId
    })), {
        enabled: !!contractId,
        onSuccess: (data) => {
            const options = data.map(group => {
                return {
                    label: group.name !== 'unassigned' ? group.name : t('contracts.collaborators.unassigned_group'),
                    options: group.members?.map((member) =>
                        ({ label: `${member.givenName} ${member.familyName}`, value: member._id, isGroup: false, })) ?? []
                }
            })

            if (withGroups) {
                const groups = {
                    label: t('contracts.collaborators.groups'),
                    options: data.filter(g => g.name !== 'unassigned').map((group) =>
                        ({ label: group.name, value: group._id, isGroup: true }))
                }

                options.push(groups)
            }

            setGroupOptions(options)
        }
    })



    return (
        <Select
            styles={reactSelectStyles}
            placeholder={t('contracts.collaborators.choose_collaborator')}
            // className="mx-3"
            isLoading={isLoading}
            options={groupOptions}
            {...rest}
        />
    )
}

